import { $$ } from "./dom.js";
import { closeDrawer } from "./menu.js";

export function initScroll() {
  $$('a[href^="#"]').forEach((link) => {
    link.addEventListener("click", (e) => {
      const id = link.getAttribute("href").slice(1);
      if (!id) return;
      const target = document.getElementById(id);
      if (!target) return;
      e.preventDefault();
      const heading = target.querySelector("h2");
      const focusTarget = heading || target;
      if (!focusTarget.hasAttribute("tabindex")) {
        focusTarget.setAttribute("tabindex", "-1");
      }
      target.scrollIntoView({
        behavior: window.matchMedia("(prefers-reduced-motion: reduce)").matches ? "auto" : "smooth",
        block: "start",
      });
      focusTarget.focus({ preventScroll: true });
      history.pushState(null, "", "#" + id);
      closeDrawer();
    });
  });
}
